import * as React from 'react';
import Axios from 'axios';
import {
  PickerOptions,
  PickerResponse,
} from 'filestack-js/build/main/lib/picker';
import { InputFile } from 'filestack-js';
import fileStackClient from '@app/filestack';
import { isValidUrl } from 'utils';
import Avatar from './Avatar';

interface AvatarPickerState {
  avatarFilestackId: string;
  avatarFullFilestackId: string; // un-cropped version
}

interface AvatarPickerProps {
  avatarFilestackId: string;
  avatarFullFilestackId: string; // un-cropped version
  userId: string;
}

class AvatarPicker extends React.Component<
  AvatarPickerProps,
  AvatarPickerState
> {
  constructor(props: AvatarPickerProps) {
    super(props);
    this.state = {
      avatarFilestackId: props.avatarFilestackId,
      avatarFullFilestackId: props.avatarFullFilestackId,
    };
  }

  private editFileStackPicker = () => {
    const { avatarFullFilestackId } = this.state;
    const { userId } = this.props;
    if (!avatarFullFilestackId) return;

    const processResults = async (results: PickerResponse) => {
      const data = { results, userId };
      await Axios.post('/file/filestack', data);
      this.setState({ avatarFilestackId: results.filesUploaded[0].handle });
    };

    const opts: PickerOptions = {
      accept: 'image/*',
      maxSize: 1024 * 1024 * 2,
      uploadInBackground: false,
      exposeOriginalFile: true,
      transformations: { rotate: true, crop: { aspectRatio: 1, force: true } },
      onUploadDone: results => processResults(results),
    };

    const picker = fileStackClient.picker(opts);
    picker.crop([`https://cdn.filestackcontent.com/${avatarFullFilestackId}`]);
  };

  private showFileStackPicker = () => {
    const { userId } = this.props;
    let avatarFullPromise: Promise<any>;
    const processResults = async (results: PickerResponse) => {
      const originalFile = await avatarFullPromise;
      results.filesUploaded.push(originalFile);
      const data = { results, userId };
      await Axios.post('/file/filestack', data);

      this.setState({
        avatarFilestackId: results.filesUploaded[0].handle,
        avatarFullFilestackId: results.filesUploaded[1].handle,
      });
    };

    const opts: PickerOptions = {
      accept: 'image/*',
      maxSize: 1024 * 1024 * 2,
      uploadInBackground: false,
      exposeOriginalFile: true,
      fromSources: ['local_file_system', 'url'],
      transformations: { rotate: true, crop: { aspectRatio: 1, force: true } },
      onFileSelected: async file => {
        if (file.source === 'url') {
          if (!isValidUrl(file.originalPath)) {
            throw new Error('Invalid URL format. Please try again.');
          }
          avatarFullPromise = fileStackClient.storeURL(file.originalPath);
        } else {
          avatarFullPromise = fileStackClient.upload(
            file.originalFile as InputFile,
            undefined,
            { altText: 'user avatar' },
          );
        }
      },
      onUploadDone: results => processResults(results),
    };

    const picker = fileStackClient.picker(opts);
    picker.open();
  };

  public render() {
    const { avatarFilestackId } = this.state;
    return (
      <div className="profile-edit-center">
        <div className="col-md-12" style={{ margin: '2em 0' }}>
          <Avatar avatarId={avatarFilestackId} type="profile" />
        </div>
        <div className="avatar-picker-actions">
          <button
            className="btn btn-primary"
            type="button"
            onClick={this.showFileStackPicker}
          >
            + Upload New
          </button>
          <button
            className="btn btn-default"
            type="button"
            onClick={this.editFileStackPicker}
          >
            Edit Photo
          </button>
        </div>
      </div>
    );
  }
}

export default AvatarPicker;
